import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ClienteModel } from 'src/app/models/cliente';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { environment } from 'src/environments/environment';
import { TIEMPO_INACTIVO } from 'src/app/routes.constants';

@Component({
  selector: 'app-planesno',
  standalone: false,
  templateUrl: './planesno.component.html',
  styleUrl: './planesno.component.scss'
})
export class PlanesnoComponent implements OnInit {

  json: string = '';
  jsonFinal: string = '';
  nombreTextoPrincipal: string = '';
  textoInferior: string = '';
  leadId: string = '';

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  parametro: string = '';

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }
  codAsesor: string = '';
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {

        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.idLead, porcPll: '25', msnPll: 'Inactividad en tarifa sin inquilino', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.checador) {
      clearInterval(this.checador);
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute) { }

  @Input() infoCliente?: string;
  @Input() idLead?: string;
  @Input() codigoAsesor?: string = '';
  @Input() bitacoraId: string = '';
  precioCanon: number = 0;
  segundoCanon: number = 0;

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);

        this.precioCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.5;
        const porceCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.35;
        this.segundoCanon = porceCanon;

        this.nombreTextoPrincipal = this.datosGenerales.Cliente.nombreCliente + ", ya están listas  tus opciones";
        this.textoInferior = "*El precio aplica para una vigencia de 12 meses";
      }
      else {
        this.nombreTextoPrincipal = "Nombre, ya están listas  tus opciones";
        this.textoInferior = "*El precio aplica para una vigencia de 12 meses";

        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';
        this.codAsesor = this.codigoAsesor !== undefined ? this.codigoAsesor : '';
        this.IdBitacora = this.bitacoraId !== undefined ? this.bitacoraId : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);

          this.precioCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.5;
          const porceCanon = (this.datosGenerales.InfoArrendamiento.valorArriendo + this.datosGenerales.InfoArrendamiento.valorAdministracion) * 0.35;
          this.segundoCanon = porceCanon;

        }
      }
    });
  }
}
